// axios.js

import axios from 'axios';
import {
    API_BASE_URL,
    API_KEY
} from '../../env';

// Create an instance of Axios
const axiosInstance = axios.create({
    baseURL: API_BASE_URL, // Your API base URL
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
    function (config) {
        // Add custom headers to the request
        config.headers['Authorization'] = "JWT " + JSON.parse(localStorage.getItem("token"));
        config.headers['x-api-key'] = API_KEY;
        return config;
    },
    function (error) {
        // Handle request errors
        return Promise.reject(error);
    }
);

const refreshToken = () => {
    return (
        // It's critical to use a different axios instance here to prevent infinite loop
        axios
        .post(API_BASE_URL + "/api/token/refresh", {
            refresh: JSON.parse(localStorage.getItem("refresh")),
        })
        .then((response) => {
            localStorage.setItem("token", JSON.stringify(response.data.token));
            return response.data;
        }).catch((error) => {
            console.error("Error fetching refresh token:", error);
            throw error; // Re-throw to handle 401 errors
        })
    )
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        await refreshToken();

        const token = JSON.parse(localStorage.getItem("token"));

        if (token) {
          originalRequest.headers.Authorization = `JWT ${token}`;
        }

        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error("Error refreshing token:", refreshError);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
